import React, { useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import Modal from "./Modal";

const DeleteDialog = (props) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const confirmDelete = () => {
    props.handleDelete(props.data);
    setOpen(false);
  };

  return (
    <>
      <IconButton title="Eliminar" size="small" onClick={handleOpen}>
        <DeleteOutlineOutlinedIcon fontSize="small" />
      </IconButton>

      <Modal open={open} handleClose={handleClose} size="sm">
        <Typography variant="titulo" paragraph>
          {props.text}
        </Typography>
        {props.subText ? (
          <Typography variant="cuerpo" paragraph>
            {props.subText}
          </Typography>
        ) : (
          ""
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Button sx={{ m: 1 }} variant="verde" onClick={confirmDelete}>
            {"Confirmar"}
          </Button>
          <Button sx={{ m: 1 }} variant="plata" onClick={handleClose}>
            {"Cancelar"}
          </Button>
        </Box>
      </Modal>
    </>
  );
};

DeleteDialog.propTypes = {
  handleDelete: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

DeleteDialog.defaultProps = {
  text: "¿Seguro/a que desea eliminar?",
  subText: null,
};

export default DeleteDialog;
